import { useEffect, useRef, useState } from 'react';
import config from '../../constants/config.js';
import './../../styles/Dashboard.css';
import { useToast } from '../../context/ToastProvider.js';
import FontEditorModal from './FontEditorModal.js';
import FontPreview from './FontPreview.js';

function FontsTable( { fonts , loading , pagination , goToPreviousPage, goToNextPage , onUpdate } ) {
    const [ openMenuIndex, setOpenMenuIndex ] = useState( null );
    const [ disableActions , setDisableActions ] = useState( false );
    const [ showModal, setShowModal ] = useState( false );
    const [ fontToEdit, setFontToEdit ] = useState( null );
    const [ previewFont, setPreviewFont ] = useState( '' );
    const [ showPreviewModal, setShowPreviewModal ] = useState( false );

    const menuRefs = useRef( [] );
    const addToast = useToast();

    async function toggleFont( fontId , newStatus , menuIndex ) {
        setDisableActions( true );
        try {
            const url = `${config.app.API_URL}/api/${config.app.REACT_APP_API_VERSION}/fonts/${encodeURIComponent(fontId)}/${encodeURIComponent( newStatus )}`;
            const requestSettings = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify( {} )
            };

            const response = await fetch( url , requestSettings );
            addToast( `Toggled Font. New status: "${newStatus}"`, false , 5000 );
            toggleMenu( menuIndex );

            if ( typeof ( onUpdate ) === 'function' ) {
                onUpdate();
            }
        } catch ( error ) {
            console.log( error );
        } finally {
            setDisableActions( false )
        }
    }

    async function removeFont( fontId , menuIndex ) {
        setDisableActions( true );
        try {
            const url = `${config.app.API_URL}/api/${config.app.REACT_APP_API_VERSION}/fonts/${encodeURIComponent(fontId)}`;
            const requestSettings = {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                }
            };

            const response = await fetch( url , requestSettings );
            addToast( `Succesfully removed the font`, false , 5000 );
            toggleMenu( menuIndex );

            if ( typeof ( onUpdate ) === 'function' ) {
                onUpdate();
            }
        } catch ( error ) {
            console.log( error );
        } finally {
            setDisableActions( false )
        }
    }

    function toggleMenu( index ) {
        setOpenMenuIndex( ( prevIndex ) => ( prevIndex === index ? null : index ) );
    }

    function formatTimeAgo( timestamp ) {
        const now = new Date();
        const lastModified = new Date(timestamp);

        if ( isNaN( lastModified.getTime() ) ) {
            return "NEVER";
        }

        const diffInSeconds = Math.floor((now - lastModified) / 1000);
    
        if (diffInSeconds < 60) {
            return `${diffInSeconds} sec(s) ago`;
        } else if (diffInSeconds < 3600) {
            return `${Math.floor(diffInSeconds / 60)} min(s) ago`;
        } else if (diffInSeconds < 86400) {
            return `${Math.floor(diffInSeconds / 3600)} hour(s) ago`;
        } else if (diffInSeconds < 432000) {
            return `${Math.floor(diffInSeconds / 86400)} day(s) ago`;
        } else {
            return lastModified.toLocaleDateString();
        }
    }

    useEffect(() => {
        function handleClickOutside(event) {
            if ( openMenuIndex !== null && menuRefs.current[openMenuIndex] && 
                !menuRefs.current[ openMenuIndex ].contains(event.target)) {
                setOpenMenuIndex(null);
            }
        }

        if ( openMenuIndex !== null ) {
            document.addEventListener( "mousedown", handleClickOutside );
        }

        return () => {
            document.removeEventListener( "mousedown", handleClickOutside );
        };
    }, [ openMenuIndex ] );

    if ( loading ) {
        return(
            <div className="product-table-skeleton"></div>
        )
    }

    return(
        <div>
            <div className="dashboard-table">
                <table id="recent-products">
                    <thead>
                        <tr>
                            <th>FONT NAME</th>
                            <th>FONT WEIGHT</th>
                            <th>FONT STYLE</th>
                            <th>STATUS</th>
                            <th>LAST MODIFIED</th>
                            <th>{/* ACTIONS */}</th>
                        </tr>
                    </thead>
                    <tbody>
                        { 
                            fonts?.length > 0 ? 
                                fonts?.map( ( row , index ) => {
                                    return(
                                        <tr className="product-row" key={ index }>
                                            <td>
                                                <div className="product-details">
                                                    <div className="product-title">
                                                        {row?.font_name}
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="weight normal">
                                                    { row?.font_weight || "" }
                                                </div>
                                            </td>
                                            <td>
                                                <div className="style normal">
                                                    { row?.font_style || "" }
                                                </div>
                                            </td>
                                            <td>
                                                <div className="status normal">
                                                    { row?.status || "" }
                                                </div>
                                            </td>
                                            <td>
                                                <div className="last-editor normal">
                                                    { formatTimeAgo( row?.last_modified ) }
                                                </div>
                                            </td>
                                            <td>
                                                <div className="actions" ref={(el) => menuRefs.current[index] = el}>
                                                    <button className="more-options" onClick={() => toggleMenu( index )}>
                                                        ...
                                                    </button>

                                                    { openMenuIndex === index && (
                                                        <ul className="options-menu">
                                                            <li className="option-menu-li">
                                                                <button disabled={disableActions} className="option-action" onClick={ () => {
                                                                    setFontToEdit( row );
                                                                    setShowModal( true );
                                                                } }>
                                                                    Edit
                                                                </button>
                                                            </li>

                                                            <li className="option-menu-li">
                                                                <button disabled={disableActions} className="option-action" onClick={() => {
                                                                    setPreviewFont( row.font_name );
                                                                    setShowPreviewModal( true );
                                                                    toggleMenu( index );
                                                                }}>
                                                                    Preview
                                                                </button>
                                                            </li>
                                                            
                                                            {/* Enable / Disable */}
                                                            { row?.status === "Enabled" &&
                                                                <li className="option-menu-li">
                                                                    <button disabled={disableActions} className="option-action" onClick={ () => toggleFont( row.id , "Disabled" , index ) }>
                                                                        Disable
                                                                    </button>
                                                                </li>
                                                            }

                                                            { row?.status === "Disabled" &&
                                                                <li className="option-menu-li">
                                                                    <button disabled={disableActions} className="option-action" onClick={ () => toggleFont( row.id , "Enabled" , index ) }>
                                                                        Enable
                                                                    </button>
                                                                </li>
                                                            }
                                                            
                                                            <li className="option-menu-li">
                                                                <button disabled={disableActions} className="option-action" onClick={ () => removeFont( row.id , index ) }>
                                                                    Remove
                                                                </button>
                                                            </li>
                                                        </ul>
                                                    )}
                                                </div>
                                            </td>
                                        </tr>
                                    )
                                })
                            :
                            <tr>
                                <td colSpan="5">No Fonts Found</td>
                            </tr>
                        }
                    </tbody>
                </table>

                { pagination != null && pagination?.totalPages > 1 &&
                    <div className="pagination">
                        <button onClick={goToPreviousPage} disabled={pagination.currentPage === 1}>
                            Previous
                        </button>
                        <span>Page {pagination.currentPage} of {pagination.totalPages}</span>
                        <button onClick={goToNextPage} disabled={pagination.currentPage === pagination.totalPages}>
                            Next
                        </button>
                    </div>
                }

                { showModal && (
                    <FontEditorModal
                        isOpen={ showModal }
                        onClose={() => { 
                            setShowModal(false)
                        }}
                        onAdd={ () => { 
                            if ( typeof ( onUpdate ) === 'function' ) {
                                onUpdate();
                            }
                        }}
                        initialData={ fontToEdit }
                    />
                )}
                
                { showPreviewModal && (
                    <FontPreview 
                        fontName={ previewFont }
                        onClose={() => {
                            setShowPreviewModal( false )
                        }}
                    />
                )}
                
            </div>
        </div>
    )
}

export default FontsTable;